export { default } from "./GymSplashRoot";
